import DmnModdle from 'dmn-moddle';
import { buildModel } from './model';

const DRG_ELEMENT_TYPES = new Set([
  'dmn:Decision',
  'dmn:BusinessKnowledgeModel',
  'dmn:KnowledgeSource',
  'dmn:InputData',
  'dmn:DecisionService',
]);

export class DmnReader {
  constructor() {
    this._moddleExtensions = {};
    this._moddle = null;
    this._plugins = [];
  }

  addModdleExtension(name, descriptor) {
    this._moddleExtensions[name] = descriptor;
    this._moddle = null;
  }

  addReaderPlugin(plugin) {
    this._plugins.push(plugin);
  }

  _getModdle() {
    if (!this._moddle) {
      this._moddle = DmnModdle(this._moddleExtensions);
    }
    return this._moddle;
  }

  getModdle() {
    return this._getModdle();
  }

  async read(xmlString) {
    if (typeof xmlString !== 'string' || !xmlString.trim()) {
      throw new Error('[DmnReader] xml string is required');
    }

    const moddle = this._getModdle();
    const parseResult = await moddle.fromXML(xmlString);
    const definitions = parseResult.rootElement;
    const warnings = [...(parseResult.warnings || [])];

    if (!definitions || definitions.$type !== 'dmn:Definitions') {
      throw new Error('[DmnReader] root element is not dmn:Definitions');
    }

    const model = buildModel(definitions);

    this._plugins.forEach((plugin) => {
      if (typeof plugin.afterRead === 'function') {
        try { plugin.afterRead({ definitions, model, warnings }); }
        catch (err) { warnings.push(err); }
      }
    });

    return { definitions, model, warnings };
  }
}

export { DRG_ELEMENT_TYPES };
